module.exports = __webpack_public_path__ + "img/fig15.dcff21c3.jpg";